<template>
  <div class="main-page-layout">
    <a-layout class="main-alayout">
      <a-layout-header :style="headerStyle" style="height:60px;background: #000;display:flex;justify-content:space-between;align-items:center;">
      <!-- <a-layout-header :style="headerStyle" style="height:60px;background: #21205b;display:flex;justify-content:space-between;align-items:center;"> -->
      <!-- <a-layout-header :style="headerStyle" style="height:54px;background: linear-gradient( 131deg, #4E7DE5 0%, #2750CC 100%), rgba(0,0,0,0.05);display:flex;justify-content:space-between;align-items:center;"> -->
        <div class="header-logo">
          <TopNavDock />
          <img class="header-logo-image" src="@/assets/images/logo/logo.png" />
          <img class="header-logo-image-text" src="@/assets/images/logo/logo-text.jpg" />
          <!-- <span>火星视界</span> -->
        </div>
        <div>
          <a-alert v-if="isDev" type="warning" show-icon style="padding-top: 10px;padding-bottom: 10px;">
            <template #description>
              「 这是测试页面，正式地址请访问 <a href="http://marsadmin.marsvis.com">marsadmin.marsvis.com</a> 」
            </template>
          </a-alert>
        </div>
        <div style="display: flex;">
          <img src="@/assets/images/task.svg" class="task-center" alt="" @click="goRouter('/keywords/taskcenter')">
          <span style="font-size: 14px;">当前用户: {{username}}</span>
          <div style="height: 12px;
            width: 1px;
            background: rgb(255, 255, 255);
            margin-top: 21px;
            margin-left: 14px;
            opacity: .6;"></div>
          <div class="main-layout-logout" @click="handleLogout">
            <PoweroffOutlined />
            <span style="margin-left:2px;">退出</span>
          </div>
        </div>
      </a-layout-header>
      <a-layout>
        <a-layout-sider :style="siderStyle" :trigger="null" :collapsed-width="0" v-model:collapsed="collapsed" collapsible width="200">
          <div class="custom-collapsed-trigger" :style="{right:collapsed?'-24px':'-16px'}" @click="() => (collapsed = !collapsed)">
            <DoubleRightOutlined v-if="collapsed" />
            <DoubleLeftOutlined v-else />
          </div>
          <div class="main-layout-side" v-if="!collapsed">
            <div class="main-layout-navi"><Navi /></div>
          </div>
        </a-layout-sider>
        <a-layout-content :style="layoutStyle">
          <a-layout-content :style="contentStyle">
            <RouterView />
          </a-layout-content>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script lang='ts' setup>
import { PoweroffOutlined, DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons-vue';
import Navi from '@/components/Navi.vue';
import {useStore} from 'vuex'
import {reactive,computed,ref, onMounted} from 'vue'
import request from '@/utils/request'
import {UserRoleMap} from '@/utils/macro.js'
import Cookies from 'js-cookie'
import TopNavDock from '@/components/TopNavDock.vue'
import { useRouter } from 'vue-router';

const router = useRouter()
const isDev = computed(() => window.location.origin.includes('sandbox'))
const collapsed = ref<boolean>(false);
const headerStyle = {
  color: '#fff',
  height: 60,
  paddingInline: '0 16px',
  lineHeight: '60px',
  // backgroundColor: '#275BFF',
  // backgroundColor: '#737afe',
  // backgroundColor: '#69B0F3',
  // backgroundColor: '#000',

};

const contentStyle = {
  backgroundColor: '#fff',
  // backgroundColor: '#F5F7F9',
  padding: '12px 18px 0',
  flex: 'auto',
};

const layoutStyle = {
  display: 'flex',
  flexDirection: 'column',
}

const siderStyle = {
  backgroundColor: '#fff',
};
const store = useStore()
const username = computed(() => store.state.user.username)

const handleLogout = () => {
  request.get(`/api/users/logout`).then(() => {
    location.href="/"
    Cookies.remove('token_0')
  })
}
function goRouter(path) {
  router.push({path})
}
</script>
<style lang='scss'>
.main-page-layout {
  height: 100%;
  width: 100%;
  // background: linear-gradient( 270deg, #D2E8FF 0%, #DAE5FF 31.14%, #DDE4FF 44.58%, #E1F0FF 100%);

  .main-alayout {
    height: 100%;
  }
  .header-logo {
    display: flex;
    align-items: center;
    .header-logo-image {
      // width: 30px;
      height: 40px;
      // border-radius: 50%;
      // border: 1px solid #fff;
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // margin-right: 12px;
      // &>img {
      //   height: 100%;
      // }
    }
    .header-logo-image-text {
      height: 50px;
      margin-left: 10px;
    }
    &>span {
      font-family: YouSheBiaoTiHei;
      color: #FFF; 
      font-size: 24px;
    }
  }
  .main-layout-side {
    display: flex;
    flex-direction: column;
    padding: 20px 0 20px 0px;
    height: 100%;
    border-right: 1px solid #eee;
    .main-layout-navi {
      flex: auto;
      height: 100%;
      overflow: auto;
    }
  }
}
.main-layout-logout {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: #fff;
  cursor: pointer;
  margin-left:16px;
  justify-content: center;
  &:hover {
    opacity: .8;
    font-weight: bold;
  }
  &>img {
    width: 20px;
    margin-right: 2px;
  }
}
.ant-layout .ant-layout-sider-trigger {
  background-color: rgba(196, 196, 196, 0.4) !important;
  color: #333 !important;
}
.custom-collapsed-trigger {
  position: absolute;
  right: -16px;
  top: 0px;
  background-color: #c7c7c8;
  background-color: #fff;
  border: 1px solid #e3e2e2;
  border-left: #fff;
  padding: 3px 6px;
  border-radius: 0 8px 8px 0;
  cursor: pointer;
  &:hover {
    // box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);
    box-shadow: -4px 0px 20px 0px #D3E4FF;
  }
}
.task-center {
  height: 22px;
  margin-right:20px;
  margin-top: 16px;
  cursor:pointer;
  &:hover {
    opacity: .8;
  }
}
</style>